import { Inject } from '@odinjs/odin';
import { ContextType, DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';

import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';

class BaseController {

  historyService = HistoryService;

  private listAbortController: AbortController[] = [];

  @Inject(ContextType.DATA)
  context!: DataContext;

  getHistoryRouteParam<T>(param: string): T {
    return this.historyService.getCurrentRouteParams()[param] as T;
  }

  setAbortController(): AbortController {
    const abortController = new AbortController();
    this.listAbortController.push(abortController);
    return abortController;
  }
  clearAbortController(): void {
    this.listAbortController.forEach(item => item?.abort());
  }
}

export default BaseController;
